var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 3,
    viewBox: "0 0 15 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.49C0 0.943333 0.148096 0.56 0.444288 0.34C0.747532 0.113333 1.11425 0 1.54443 0C1.97461 0 2.34133 0.113333 2.64457 0.34C2.95487 0.56 3.11001 0.943333 3.11001 1.49C3.11001 2.02333 2.95487 2.41 2.64457 2.65C2.34133 2.88333 1.97461 3 1.54443 3C1.11425 3 0.747532 2.88333 0.444288 2.65C0.148096 2.41 0 2.02333 0 1.49Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94499 1.49C5.94499 0.943333 6.09309 0.56 6.38928 0.34C6.69252 0.113333 7.05924 0 7.48942 0C7.91961 0 8.28632 0.113333 8.58956 0.34C8.89986 0.56 9.05501 0.943333 9.05501 1.49C9.05501 2.02333 8.89986 2.41 8.58956 2.65C8.28632 2.88333 7.91961 3 7.48942 3C7.05924 3 6.69252 2.88333 6.38928 2.65C6.09309 2.41 5.94499 2.02333 5.94499 1.49Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.89 1.49C11.89 0.943333 12.0381 0.56 12.3343 0.34C12.6375 0.113333 13.0042 0 13.4344 0C13.8646 0 14.2313 0.113333 14.5346 0.34C14.8449 0.56 15 0.943333 15 1.49C15 2.02333 14.8449 2.41 14.5346 2.65C14.2313 2.88333 13.8646 3 13.4344 3C13.0042 3 12.6375 2.88333 12.3343 2.65C12.0381 2.41 11.89 2.02333 11.89 1.49Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/three-dots-icon.9a4d2177f7d9301b5fdece58f0b6c0ce.svg";
export { ForwardRef as ReactComponent };